import React, { memo } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import LabelCard from './LabelCard'

interface Props {
  imageUrl: string
  title: string
  link: string
  categoryId: string
  categoryName: string
}

const FeatureTabCard: React.FC<Props> = ({ imageUrl, title, link, categoryId, categoryName }) => {
  return (
    <article className="relative h-[200px]">
      <Link href={`/${link}`} className="block relative w-full h-full">
        <Image
          src={`${process.env.NEXT_PUBLIC_IMAGE_URL}${imageUrl}`}
          alt={title}
          title={title}
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 680px"
          className="object-cover"
          fill
          priority
        />
        <LabelCard categoryId={categoryId} categoryName={categoryName} />
        <h3 className="absolute bottom-0 left-0 text-lg font-title font-semibold text-white bg-gradient-to-t from-black to-transparent px-2 py-1 rounded">
          {title}
        </h3>
      </Link>
    </article>
  )
}

export default memo(FeatureTabCard)
